import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { NativeService } from 'src/service/native.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { DatePipe } from '@angular/common';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
declare var app;
@Component({
  selector: 'app-qc-customer-tag',
  templateUrl: './qc-customer-tag.component.html',
  styleUrls: ['./qc-customer-tag.component.scss']
})
export class QcCustomerTagComponent extends GridBaseCase implements AfterViewInit {
  tabsIndex = 1;
  isShow = true;
  zheidieOneFlag = false;
  zheidieTwoFlag = true;
  zheidieThreeFlag = true;
  information: any = {};
  month: any = "";
  content: any = null;
  segmentVal: any = 0;
  typeout: any = null;
  searchDate = null;
  searcholdDate = null;
  dataArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选

  baseObj: any = {};
  babyObj: any = {};
  tagArr: Array<any> = new Array<any>();
  alreadyTagArr: Array<any> = new Array<any>();//已保存过用户标签

  oneTag: any = [];
  twoTag: any = [];
  kid: string;
  typeall:any=[];//用户标签
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private native: NativeService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    private inappbrowser: InAppBrowser
  ) {
    super();
    // this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    // this.baseService.FixedSubmitBtn.configName = "ReminderDetail";
    // this.baseService.FixedSubmitBtn.isShow = true;
    // this.baseService.FixedSubmitBtn.text = "添加沟通记录";
    // this.baseService.FixedSubmitBtn.type = 1;
    
    // this.month = this.com.getNow;
  }

  ngAfterViewInit
    () {
      this.baseService.FixedSubmitBtn.configName = "qcTag";
      this.baseService.FixedSubmitBtn.isShow = true;
      this.baseService.FixedSubmitBtn.text = "完成";
      this.baseService.FixedSubmitBtn.type = 7;
  }

  tabChange(num: number) {
    console.log("1008611");
    if (this.tabsIndex != num) {
      this.isShow = true;
    } else {
      this.isShow = !this.isShow;
    }
    this.tabsIndex = num;
    if (num == 1) {
      this.zheidieOneFlag = !this.isShow;
      this.zheidieTwoFlag = true;
      this.zheidieThreeFlag = true;
    } else if (num == 2) {
      this.zheidieTwoFlag = !this.isShow;
      this.zheidieOneFlag = true;
      this.zheidieThreeFlag = true;
    } else if (num == 3) {
      this.zheidieThreeFlag = !this.isShow;
      this.zheidieOneFlag = true;
      this.zheidieTwoFlag = true;

    }

    console.log(num, this.isShow);
  }

  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if (that.infiniteScroll) {
        that.infiniteScroll.disabled = true;
      }

    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  tabsEvent(index) {
    this.tabsIndex = index;
    this.LoadData(1);
  }
  /**
   * 打电话
   * @param event 电话号码
   */
  EventCall(event) {
    this.native.GetCallPhone(event).then(fail => {
      console.log(fail);
    }).catch(error => {
      console.log(error);
    })
  }
  /**
   * 发短信
   * @param event 电话号码
   */
  EventMessage(event) {
    let text = "";
    if (this.content) {
      text = this.content.value
    }
    this.native.GetSendMsg(event, text).then(sucess => {
      console.log(sucess);
    }).catch(error => {
      console.log(error);
    });
  }


  EventDateTimeClick() {
    let that = this;
    let _obj = {
      value: that.month,
      format: "yyyymmdd"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.month = that.formatDate(data.value);
      that.LoadData(1);
    }).catch(eror => {
      //console.log(eror);
    });
       
  }

  formatDate(date) {
    if (date) {
      let _date = new Date(date.replace(/-/g, "/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth() + 1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
    } else {
      return date;
    }
  }

  LoadData(PageNumber) {
    var that = this;
    let parms = that.activaRouter.snapshot.paramMap.get("type");
    if (parms && parms.length >= 1) {
      that.kid = parms.split('&')[0];
    }
    this.jbzlLoad();
    // this.bbzlLoad();
    this.khxqLoad();
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');

    if(PageName=="WCustomerInfo")
    {
      let customerTag=that.com.GetStorageKey("customerTag") || {};
      //会员足迹详情
        if(customerTag&&customerTag["typeall"])
        {
          that.typeall=customerTag["typeall"].value;
        }
      }
  }

  //基本信息
  jbzlLoad() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName = "MembersInfoManagementXML";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["a_ID"] = that.kid;
    body.RequestBody = JSON.stringify(typeObj);

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        if (data.Status.Datas&&data.Status.Datas.length > 0) {
          that.baseObj = data.Status.Datas[0];
          console.log("that.baseObjthat.baseObjthat.baseObjthat.baseObj")
          console.log(that.baseObj)
          console.log(that.baseObj.a_BodyBirthday);
          if(that.baseObj.a_BodyBirthday){
            
          // var yy=new Date(that.baseObj.e_BBbirthday.replace());
          // var jj=yy.getFullYear()+"/"+(yy.getMonth()+1)+"/"+yy.getDate();
          if(that.baseObj.a_BodyBirthday.split(" ")[0]){
            that.month=that.baseObj.a_BodyBirthday.split(" ")[0];
            console.log("that.monththat.monththat.monththat.monththat.monththat.monththat.month")
            console.log(that.month);
          }
        }
        if(that.baseObj.a_Name){
          that.baseObj.a_Name=that.com.FormatName(that.baseObj.a_Name);
          console.log( that.baseObj.a_Name);
        }
        if(that.baseObj.a_TelPhone){
          that.baseObj.a_TelPhone=that.com.PhoneNum(that.baseObj.a_TelPhone);
          console.log( that.baseObj.a_TelPhone);
        }
      }
        console.log("基本详情", this.baseObj);
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }



  //客户详情
  khxqLoad() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName = "TBTagManageXML";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    body.RequestBody = JSON.stringify(typeObj);
    body.RowsPerPage =0;//客户详情

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.tagArr = [];
        let _temp: Array<any> = new Array<any>();//新的对象；
        data.Status.Datas.forEach(item => {
          let _paremas: any = { childArr: [] };
          _paremas["b_Code"] = item.b_Code;//分组Code
          _paremas["b_Name"] = item.b_Name;//分组Name
          let _child: any = {};
          _child["a_ID"] = item.a_ID;//明细ID
          _child["a_Name"] = item.a_Name;//明细Name
          _child["a_Code"] = item.a_Code;//明细Code
          _child["ischeck"] = false;//是否选中,默认不选中
          if (_temp.length <= 0) {
            _paremas.childArr.push(_child);
            _temp.push(_paremas);
          } else {
            if (_temp.find(px => px.b_Code == item.b_Code)) {
              _temp.find(px => px.b_Code == item.b_Code).childArr.push(_child);
            } else {
              _paremas.childArr.push(_child);
              _temp.push(_paremas);
            }
          }
        });
        that.tagArr = _temp;
       that.alreadyTags();
        console.log("用户标签详情", this.tagArr);
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length) {
          // that.infiniteScroll.disabled = true;
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = true;
          }
        } else {
          if (that.infiniteScroll) {
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }else {
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  
  //加载已有用户标签
  alreadyTags() {
    let that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.ConfigName = "TBMemberTagXML";
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    typeObj["a_FK_MembersInfoManagement_ID"] = that.kid;
    body.SpecialParameter = "StopWork";
    body.RequestBody = JSON.stringify(typeObj);

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.alreadyTagArr = data.Status.Datas;//已保存 的标签
        if (that.tagArr.length > 0) {
          that.tagArr.forEach(item => {
            data.Status.Datas.forEach(f => {
              // console.log("已保存",f.a_FK_TBTagManage_ID);
              if (item.childArr.find(c => c.a_ID == f.a_FK_TBTagManage_ID)) {
                // console.log("点击",item.childArr)
                item.childArr.find(c => c.a_ID == f.a_FK_TBTagManage_ID).ischeck = true;
              item["keyid"]=f.a_ID;
              }else{
                // item.childArr.find(c => c.a_ID != f.a_FK_TBTagManage_ID).ischeck = false;
              }  

            });
          });
        }
      }else{
        that.msg.Alert(data.ResponseMessage.ErrorMessage);
      }
      console.log(that.tagArr);
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  SelectCheck(e, i, item) {
    const that = this;
    item["ischeck"] = true;
    that.tagArr[i]["childArr"].forEach(childItem => {
      if (childItem["a_ID"] != item["a_ID"]) {
        childItem["ischeck"] = false;
      }
    })
  }

  /**
   * 打开微信
   */
  Eventweixin() {
    console.log("打开微信");
    this.inappbrowser.create("weixin://");
  }
  /**
   * 添加沟通记录
   * @param tabindex 选项卡下标
   * @param item 当前行数据
   */
  EventClick(tabindex) {
    const id = this.activaRouter.snapshot.paramMap.get('type');
    if (id) {
      // this.router.navigate([this.config[tabindex].url + id.split('&')[0]]);
      this.com.Go(this.config[tabindex].url + id.split('&')[0]);
      this.com.setHistoryUrl();
    }
  }



  //保存
  EventClickSub() {
    let that = this;
    that.information = that.com.GetStorageKey("customer") || {};
    if (that.information["birthday"] && that.information["birthday"].value) {
      that.information["birthday"].value = that.information["birthday"].value.toString().replace(/-/g, "/");
    }
    that.element = that.config[that.tabsIndex];
    console.log(that.config);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = 1;
    body.ConfigName = "TBMemberTagXML";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let typeObj = {};
    let send = [];
    that.tagArr.forEach(item => {
      item.childArr.forEach(c => {
        if (c.ischeck) {
            // if(that.alreadyTagArr.find(n=>n.a_FK_TBTagManage_ID==))
            if(item.keyid){
            send.push({ "a_ID": item.keyid,"Code":c.a_Code, "a_FK_TBTagManage_ID": c.a_ID });
            }else{
              send.push({ "a_FK_MembersInfoManagement_ID": that.kid,"Code":c.a_Code, "a_FK_TBTagManage_ID": c.a_ID });
            } 
        }
      });
    });
    console.log("send", send);
    if (that.alreadyTagArr.length > 0) {
      body.SpecialParameter = "ProvisionalPlan";
      body.OpType = "edite";
      body.ConfigType = "form";
    } else {
      body.SpecialParameter = "StopWork";
      body.OpType = "add";
      body.ConfigType = "form";
    }
    body.RequestBody = JSON.stringify(send);
    console.log(that.tagArr);
    that.msg.Confirm("确定保存吗？","取消","确定").then(res=>{
       if(res){
        if(send.length==0){
          that.msg.Alert("保存成功").then(()=>{
            that.com.goBack();
          });
          return;
        }
       
        that.http.post(app.DEFAULTURL, body).then(data => {
          /****判断是否第一页begin****/
          /****判断是否第一页end****/
          if (data.ResponseMessage.Success) {
              that.msg.Alert("保存成功").then(()=>{
                that.com.goBack();
              });
          }else {
            that.msg.Alert(data.ResponseMessage.ErrorMessage);
            // console.log(data.ResponseMessage.ErrorMessage);
          }
    
        }).catch(error => {
          that.msg.Alert(error.ResponseMessage.ErrorMessage);
          that.apiObj['status'] = false;
          that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
          that.loading = true;
          console.log(error);
        });
       }
    });
    

  }

  EventSubmitClick() {
    console.log(this.config);
    // this.EventClick(2);
    this.EventClickSub();
  }
 
}








